export function getSessionStorageByKeys<T extends readonly string[]>(keys: T): Record<T[number], string> | null {
  const result: Partial<Record<T[number], string>> = {};

  keys.forEach((key) => {
    const value = sessionStorage.getItem(key);
    if (value) {
      result[key as T[number]] = value;
    }
  });

  return Object.keys(result).length > 0 ? (result as Record<T[number], string>) : null;
}
